import { BlogLayout } from "../../containers";
import { Main } from "../../components";

function Home() {
  return (
    <BlogLayout>
      <Main />
    </BlogLayout>
  );
}

export default Home;
